module.exports = __webpack_public_path__ + "img/craftBannerKitchen.8f210ee.webp";